import { Inject, Injectable } from '@angular/core';
import { KeycloakAuthGuard, KeycloakService } from 'eurogard-keycloak';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({providedIn: 'root'})
export class AuthGuard extends KeycloakAuthGuard {

  constructor(
    protected override readonly router: Router,
    @Inject(KeycloakService)
    protected readonly keycloak: KeycloakService,
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    // Force the user to log in if currently unauthenticated.
    if (!this.authenticated) {
      console.log('AuthGuard: not authenticated, redirecting to login');
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url,
      });
    }

    return true;
  }

}
